<template>
  <div class="home">
    <section id="slider"><!--slider-->
		<div class="container" style="width: 100%">
			<div class="row">
				<div class="col-sm-12" style="padding: 0;">
					<carousel :per-page="1"  :navigationEnabled="true" :autoplay="true" :loop="true" :autoplay-timeout="5000" :pagination-padding="2" >
						<slide style="background-image: url('images/banner/01.jpg'); background-position: center; background-repeat: no-repeat; background-size: cover;">
							<div class="opacityDiv"></div>
							<div class="msgBanner" align="center">Máquinas prontas para execução de serviços com<br> PRECISÃO e QUALIDADE</div>
							<!-- <img src="images/banner/bannernovo.jpg" alt="" class="imgBanner" > -->
						</slide>
						<slide style="background-image: url('images/banner/02.jpg'); background-position: center; background-repeat: no-repeat; background-size: cover;">
							<div class="opacityDiv"></div>
							<div class="msgBanner" align="center">Máquinas prontas para execução de serviços com<br> PRECISÃO e QUALIDADE</div>
						</slide>
					</carousel>
				</div>
			</div>
		</div>
	</section><!--/slider-->
	<section>
		<div style="width:100%; background: #383a3e url('./images/usinagem.jpg') top center no-repeat;">
		
			<div style="width:90%; max-width:700px; margin:0 auto; color:#FFFFFF; font-size:15px; line-height:24px;">
				<div class="tituloPesquisa" align="center">O que você procura?</div>
				<div style="padding-bottom: 70px">
					<!-- <form role="search" id="searchform" :action="pesquisar" class="radius-xl"> -->
						<div class="input-group row" style="width: 100%; display: flex">
							<input type="text" class="form-control inputRound" placeholder="Pesquisar..." v-model="searchText" @keyup.enter="pesquisar">
							<a @click="pesquisar" style="margin-top: 16px;"><div><i class="fa fa-search iconSearch" ></i></div></a>
						</div><!-- /input-group -->
					<!-- </form> -->
				</div>
			</div>
		</div>
	</section>
	<section id="one" class="wrapper style1 special">
		<div class="procurarCategoria">
				<div style="width:90%; max-width:700px; margin:0 auto; color:#FFFFFF; font-size:15px; line-height:24px;">
						<div class="tituloPesquisa" align="center">Procurar por Categorias</div>
						<div class="row" style="padding-bottom: 40px; text-align: center">
							<div class="col-md-4 col-sm-12 col-xs-12 wow fadeIn animated divIcon">
								<router-link to="/produtos" class="linksIndex">
									<i class="fas fa-cog icon big rounded color1"></i><br>
									<label class="lblProcurarCategoria">Ferramentas Modulares</label>
								</router-link>
							</div>
							<div class="col-md-4 col-sm-12 col-xs-12 wow fadeIn animated divIcon">
								<router-link to="/servicos" class="linksIndex">
									<i class="fas fa-handshake icon big rounded color1"></i>
									<label class="lblProcurarCategoria">Prestação de Serviços</label>
								</router-link>
							</div>
							<div class="col-md-4 col-sm-12 col-xs-12 wow fadeIn animated divIcon">
								<router-link to="/servicos" class="linksIndex">
									<i class="fa fa-wrench icon big rounded color1"></i><br>
									<label class="lblProcurarCategoria">Terceirização de Serviços</label>
								</router-link>
							</div>
						</div>
					</div>
		</div>
	</section>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'home',
  components: {
  },
  data() {
    return {
			categorias: [],
			searchText: ''
    }
  },
  created() {
    var cat = firebase.database().ref('categorias/')
    cat.on('child_added', (data) => {
      console.log('categorias -> ', data.val())
      this.categorias.push(data.val().nome)
    });
	},
	methods: {
		pesquisar () {
			this.$router.push({name: 'Servicos', params: { searchText : this.searchText } })
		}
	}
}
</script>
<style>
.imgBanner {
	width: 100%;
	height: 100%;
}

.VueCarousel-inner{
		height: 400px!important;
	}
@media screen and (min-width:1400px){
	.VueCarousel-inner{
		height: 600px!important;
	}
}
.VueCarousel-pagination{
	position: absolute;
	bottom: 0
}
.VueCarousel-navigation{
	display: none
}
.opacityDiv{
	opacity: 0.5;
    background-color: #000000;
	position: absolute;
    /* top: 0; */
    /* left: 0; */
    height: 100%;
    width: 100%;
	z-index: 0;
}
.msgBanner {
    font-size: 50px;
    line-height: 60px;
    color: #FFFFFF;
    font-family: abel;
	position: absolute;
    z-index: 2;
    width: 100%;
    top: 25%;
}
</style>
